// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  or: 'Or',
  text: 'click here to cancel and return to home page',
  title: 'return to homepage',
} as ILanguage;
